import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchAccountDocumentAvailability } from "app/services/accountDocument/accountDocument";
import { BASE_URL } from "static/constants";

export const accountDocumentApi = createApi({
  reducerPath: "accountDocumentApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query }) => ({
    getAccountDocumentAvailability: query({
      queryFn: async (accountId) => {
        try {
          return { data: await fetchAccountDocumentAvailability(accountId) };
        } catch (error) {
          // Any failure (403, 404, network) simply means no link is shown.
          return { data: {} };
        }
      },
    }),
  }),
});

export const { useGetAccountDocumentAvailabilityQuery } = accountDocumentApi;
